import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://backend.buildsupplyco.com/api/v1';

export interface GeocodeResponse {
  success: boolean;
  data?: {
    pincode: string;
    city: string;
    state: string;
    country: string;
    locality: string;
    sublocality: string;
    area: string;
    locationName: string;
    formattedAddress: string;
    placeId: string;
    geometry: {
      location: {
        lat: number;
        lng: number;
      };
    };
  };
  message?: string;
}

export interface ReverseGeocodeResponse {
  success: boolean;
  data?: {
    pincode: string;
    city: string;
    state: string;
    country: string;
    locality: string;
    sublocality: string;
    area: string;
    locationName: string;
    formattedAddress: string;
    placeId: string;
    deliveryTime?: string;
    isServiceable?: boolean;
  };
  message?: string;
}

export interface AutocompletePrediction {
  placeId: string;
  description: string;
  mainText: string;
  secondaryText: string;
}

export interface AutocompleteResponse {
  success: boolean;
  data?: AutocompletePrediction[];
  message?: string;
}

export class LocationService {
  async geocodeAddress(address: string): Promise<GeocodeResponse> {
    try {
      const response = await axios.get<GeocodeResponse>(`${API_BASE_URL}/location/geocode`, {
        params: { address }
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async reverseGeocode(lat: number, lng: number): Promise<ReverseGeocodeResponse> {
    try {
      const response = await axios.get<ReverseGeocodeResponse>(`${API_BASE_URL}/location/reverse-geocode`, {
        params: { lat, lng }
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async getAutocompletePredictions(input: string): Promise<AutocompleteResponse> {
    try {
      const response = await axios.get<AutocompleteResponse>(`${API_BASE_URL}/location/place-autocomplete`, {
        params: { input }
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async getPlaceDetails(placeId: string): Promise<GeocodeResponse> {
    try {
      const response = await axios.get<GeocodeResponse>(`${API_BASE_URL}/location/place-details`, {
        params: { placeId }
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }
}

export const locationService = new LocationService();